// Hideo - Italian translations: help page (pages/HelpPage.vue, features/help.ts).
// Keys are the English source strings used in the code (see docs/i18n.md).
import type { Dictionary } from '../types'

const it: Dictionary = {
    'Hideo logo': 'Logo di Hideo',
    'The guide could not be loaded. Check your connection and try again.': 'Non riesco a caricare la guida. Controlla la connessione e riprova.',
    'Tap a tile to read that part of the guide.': 'Tocca un riquadro per leggere quella parte della guida.',
}

export default it
